export default __webpack_public_path__ + "static/media/medium.12110195.svg";